import { Channels } from '../components/common/channelsEnum';

const channelReadableNames: Record<Channels, string> = {
  EMAIL: 'Email',
  INAPP_WEB: 'In-App for Web',
  SMS: 'SMS',
  CALL: 'Automated Calls',
  PUSH: 'Mobile Push',
  WEB_PUSH: 'Web Push'
};

const channelShortNames: Record<Channels, string> = {
  EMAIL: 'Email',
  INAPP_WEB: 'In-App',
  SMS: 'SMS',
  CALL: 'Call',
  PUSH: 'Push',
  WEB_PUSH: 'Web Push'
};

const getChannelReadableName = (channel: string | undefined): string => {
  return channelReadableNames[channel as Channels] || channel || '';
};

const getChannelShortName = (channel: string | undefined): string => {
  return channelShortNames[channel as Channels] || channel || '';
};

export { getChannelReadableName, getChannelShortName };
